<div class="container pt-5">
  <div class="row justify-content-center">
    <div class="row justify-content-center">
      <div style="display: flex; align-items: center; justify-content: center">
        <img
          src="/assets/img/PersonnelPulseLogo.png"
          style="max-height: 8vh; width: auto"
        />
      </div>
    </div>

    <div class="col-lg-6 col-md-8 mt-4 text-center">
      <div class="card p-2">
        <app-button
          (click)="onHelpClicked()"
          customCssClass="position-absolute top-0 end-0 m-2 p-1 ps-2 pe-2"
          buttonText="?"
          buttonColor="secondary"
          buttonSize="sm"
        >
        </app-button>
        <div class="card-body">
          <h4 class="mb-4">Please Sign In</h4>

          <form [formGroup]="loginForm" class="mb-3">
            <div class="mb-3">
              <label for="inputEmail" class="visually-hidden"
                >Email address</label
              >
              <input
                formControlName="login_username"
                type="email"
                id="inputEmail"
                class="form-control"
                placeholder="Enter email address"
              />
            </div>
            <div class="mb-4">
              <label for="inputPassword" class="visually-hidden"
                >Password</label
              >
              <div class="input-group">
                <input
                  [type]="isPasswordVisible ? 'text' : 'password'"
                  class="form-control"
                  formControlName="login_password"
                  placeholder="Enter password"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-light"
                    type="button"
                    (click)="togglePasswordVisibility()"
                  >
                    <i
                      class="fa"
                      [class.fa-eye]="!isPasswordVisible"
                      [class.fa-eye-slash]="isPasswordVisible"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
            <app-button
              (onClickedEvent)="submit()"
              buttonText="Sign In"
              buttonColor="primary"
              buttonSize="lg"
              [showIcon]="isLoading"
              iconClass="ms-3 fa-solid fa-spinner spin"
              customCssClass="ps-5 pe-5"
            ></app-button>

            <div *ngIf="login_error.length > 0">
              <div class="alert alert-danger d-block mt-3">
                {{ login_error }}
              </div>
            </div>
          </form>

          <div>
            <app-button
              (onClickedEvent)="onForgotPassword()"
              buttonText="Forgot Password"
              buttonColor="link-dark"
              buttonSize="sm"
              customCssClass="mt-3"
            ></app-button>
          </div>

          <div>
            <app-button
              (onClickedEvent)="onCreateAccount()"
              buttonText="Sign Up for Free"
              buttonColor="secondary"
              [buttonSize]="null"
              customCssClass="mt-4 mb-2"
            ></app-button>
          </div>
        </div>
      </div>

      <p class="mt-5">&copy; {{ year }} PersonnelPulse. All rights reserved.</p>
    </div>
  </div>
</div>
